import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { LanguageContext } from '../contexts/LanguageContext';
import { lang } from '../services';

import LanguageSelector from './form/LanguageSelector';

const HeaderMenu = ({ onClickTerms }) => {
    const { language, setLanguage } = useContext(LanguageContext);

    return (
        <div className="HeaderMenu">
            <span
                className="HeaderMenu__text-button"
                onClick={onClickTerms}
            >
                {lang.t("Terms of Use")}
            </span>
            <LanguageSelector
                selected={language}
                onChange={setLanguage}
            />
        </div>
    )
};

HeaderMenu.propTypes = {
    onClickTerms: PropTypes.func,
};

export default HeaderMenu;